export default __webpack_public_path__ + "static/tv-show-3-bd62909a8634dd72e3a3fa5eb11689e6.jpg";